import {
  ArrowLongRightIcon,
  ArrowRightIcon,
  XMarkIcon,
} from "@heroicons/react/24/outline";
import { useState } from "react";
import Dialog from ".";
import ToggleSwitch from "../commons/ToggleSwitch";
import {
  formatCrypto,
  formatCurrency,
  getAssetCoin,
  getAssetName,
} from "../../utils";
import { useBot } from "../../context/botContext";
import { IconLoading, IconWallet } from "../../assets/icons";
import SkeletonCard from "../skeletons/SkeletonCard";
import Drawer from "../commons/Drawer";
import {
  ChevronLeftIcon,
  InformationCircleIcon,
} from "@heroicons/react/16/solid";
import CoinLogo from "../commons/CoinLogo";

const DialogStopBotConvert = ({
  open,
  onClose,
  onCloseDialog,
  handleConvert,
  convertData,
  loading,
  onBack,
  botDetail,
}) => {
  const { loadingStopStartBot } = useBot();
  const [isLimitPrice, setIsLimitPrice] = useState(false);
  const [limitPrice, setLimitPrice] = useState("");
  const [isFormatted, setIsFormatted] = useState(false);

  const handleNumberChange = (e) => {
    let input = e.target.value;

    // Allow only digits and one optional dot
    if (/^[0-9]*\.?[0-9]{0,2}$/.test(input)) {
      setLimitPrice(input);
      setIsFormatted(false);
    }
  };
  const handleBlur = () => {
    if (limitPrice) {
      setLimitPrice(formatCurrency(limitPrice));
      setIsFormatted(true);
    }
  };

  const handleFocus = () => {
    if (isFormatted) {
      // Remove commas only, keep the decimal part
      const raw = limitPrice.replace(/,/g, "");
      setLimitPrice(raw);
      setIsFormatted(false);
    }
  };
  return (
    <Drawer
      open={open}
      onClose={() => {
        if (loadingStopStartBot) return;
        setIsLimitPrice(false);
        setLimitPrice("");
        onClose();
      }}
      width="550px"
    >
      <div className="h-full flex flex-col justify-between ">
        {/*  */}
        <div>
          <div className="flex items-center justify-between w-full">
            <button
              className="bg-transparent hover:bg-transparent text-[#007A78] flex !p-0"
              onClick={() => {
                if (loadingStopStartBot) return;
                setIsLimitPrice(false);
                setLimitPrice("");
                onBack();
              }}
            >
              <ChevronLeftIcon className="w-[20px] h-[20px]" /> Back
            </button>
            <h2 className="text-xl font-bold ">
              Convert to {botDetail?.coin_name?.split("/")[1] || "USDT"}
            </h2>
            <button
              className="bg-transparent hover:bg-transparent text-black !p-0"
              onClick={() => {
                if (loadingStopStartBot) return;
                setIsLimitPrice(false);
                setLimitPrice("");
                onClose();
              }}
            >
              <XMarkIcon className="w-[24px] h-[24px]" />
            </button>
          </div>
          <div className="mt-5">
            <div className="bg-[rgba(255,204,0,0.15)] gap-3 p-3 rounded-xl border border-[#FFCC00] flex items-center">
              <InformationCircleIcon className="w-full max-w-[16px] h-[16px] text-[#8F7303]" />
              <span className=" text-sm">
                The final conversion value will be calculated after the bot is
                closed and is subject to the exchange's market rate, fees, and
                potential slippage at the time of execution. Actual profits may
                vary with market volatility. Ensure you review all details
                before confirming the sell order.
              </span>
            </div>

            <div className="mt-3">
              <span className="text-[#697077]">
                {getAssetName(convertData?.symbol)} to&nbsp;
                {botDetail?.coin_name?.split("/")[1] || "USDT"}
              </span>
              <div className="flex items-center gap-2 mt-2">
                {/* <img
                  src={getAssetCoin(convertData?.symbol?.split("/")[0])}
                  alt=""
                  className="w-full max-w-[40px] h-[40px] rounded-full"
                /> */}
                <CoinLogo
                  asset={getAssetName(convertData?.symbol)}
                  className="w-full max-w-[40px] h-[40px] rounded-full"
                />
                <ArrowLongRightIcon className="w-[24px] h-[24px] text-[#B3B3B3]" />
                <div className="w-[40px] h-[40px] rounded-full bg-[#F0F0FF] flex justify-center items-center border border-[#DDE1E6]">
                  <IconWallet className="w-[35px] h-[35px]" />
                </div>
              </div>
            </div>

            <div className="relative z-[2] bg-[#F2F4F8] p-4 border border-[#DDE1E6] rounded-xl mt-4">
              <div className="flex flex-col text-[#697077]">
                <span className="block mb-1">
                  Current {getAssetName(convertData?.symbol)} Price
                </span>
                {loading ? (
                  <SkeletonCard
                    type="text"
                    lines={1}
                    widths={["70px"]}
                    heights={["10px"]}
                  />
                ) : (
                  <span className="font-bold text-black">
                    {formatCrypto(convertData?.market_limit_price || 0)}&nbsp;
                    {botDetail?.coin_name?.split("/")[1] || "USDT"}
                  </span>
                )}
              </div>
              <div className="mt-3 flex  items-center justify-between">
                <span className="block mb-1 text-[#697077]">
                  Set Limit Price
                </span>
                <div className="flex items-center gap-3">
                  <ToggleSwitch
                    checked={isLimitPrice}
                    onChange={() => setIsLimitPrice(!isLimitPrice)}
                  />
                </div>
              </div>
            </div>
            {/* {isLimitPrice && ( */}
            <div
              className={`flex items-center justify-between rounded-xl bg-[#F7F7FF] relative
                          transition-all duration-500 ease-in-out
                          p-4 py-3 pt-6
                          ${
                            isLimitPrice
                              ? "top-[-1rem]"
                              : "top-[-5rem] mb-[-3rem]"
                          }`}
            >
              <span>Limit Price</span>
              <input
                type="text"
                value={limitPrice}
                onChange={handleNumberChange}
                onBlur={handleBlur}
                onFocus={handleFocus}
                placeholder="Input limit price"
                className="bg-transparent text-base border-none outline-none w-full max-w-[250px] rounded-xl p-1 text-right px-4"
              />
            </div>
            {/* )} */}

            <div className="p-4 rounded-xl border border-[#DDE1E6]">
              <div className="flex  items-center justify-between">
                <span>Convert quantity</span>
                {loading ? (
                  <SkeletonCard
                    type="text"
                    lines={1}
                    widths={["65px"]}
                    heights={["10px"]}
                  />
                ) : (
                  <span>
                    {formatCrypto(convertData?.available_coin || 0)}{" "}
                    {getAssetName(convertData?.symbol)}
                  </span>
                )}
              </div>
              <div className="mt-4 flex  items-center justify-between">
                <span className="text-[#21272A]">
                  {botDetail?.coin_name?.split("/")[1] || "USDT"}
                </span>
                {loading ? (
                  <SkeletonCard
                    type="text"
                    lines={1}
                    widths={["60px"]}
                    heights={["10px"]}
                  />
                ) : (
                  <span className="text-base font-bold">
                    {formatCurrency(
                      Number(convertData?.available_coin || 0) *
                        Number(convertData?.current_price || 0)
                    )}{" "}
                    {botDetail?.coin_name?.split("/")[1] || "USDT"}
                  </span>
                )}
              </div>
              <div className="mt-4 flex  items-center justify-between">
                <span>Time in force</span>
                <span>Good till canceled</span>
              </div>
            </div>
          </div>
        </div>

        <button
          className="w-full relative overflow-hidden !py-3 !font-bold !text-lg !bg-[#007A78] mt-6"
          disabled={loading || loadingStopStartBot}
          onClick={() => {
            if (loading || loadingStopStartBot) return;
            handleConvert(
              // {
              //   limit_price: !!limitPrice ? limitPrice.replace(/,/g, "") : 0,
              //   set_limit_price: isLimitPrice,
              // }
              isLimitPrice
                ? {
                    limit_price: limitPrice.replace(/,/g, ""),
                    set_limit_price: isLimitPrice,
                  }
                : {},
              () => {
                setIsLimitPrice(false);
                setLimitPrice("");
              }
            );
            // onCloseDialog();
          }}
        >
          {loadingStopStartBot ? (
            <div className="animate-spin w-fit flex justify-center items-center mx-auto">
              <IconLoading className="w-[24px] h-[24px]" />
            </div>
          ) : (
            "Convert"
          )}
        </button>
      </div>
    </Drawer>
  );
};

export default DialogStopBotConvert;
